import { Span } from "../../../Typography";

export interface MenuBadgeProps {
  show?: boolean;
  backgroundColor?: string;
  label?: string;
}

export const MenuBadge: React.FC<MenuBadgeProps> = ({
  show = false,
  backgroundColor = "#FFE7CA",
  label = "New",
}) => {
  if (!show) return null;

  return (
    <Span
      sx={{
        marginLeft: "auto",
        backgroundColor,
        padding: "2px",
        fontSize: "9px",
        borderRadius: "3px",
      }}
    >
      {label}
    </Span>
  );
};

export default MenuBadge;
